import { LANDING_PAGE_URL, LOGO_CDN_URL } from "../../constants/constants"

const AppInfo: React.FC = () => {
    return (
        <div className="card card-style mb-8">
            <div className="card-content p-4 pb-0">
                <div className="text-center">
                    <img src={LOGO_CDN_URL} alt='Logo' height={50} />
                    <h5 className="mt-2 mb-4">Where Your Influence Matters.</h5>
                </div>
                <div className="text-center mb-4">
                    <a className="cursor-pointer icon me-2 icon-xs rounded-sm shadow-l mr-1 bg-instagram" href="https://www.instagram.com/influns_in/" target="_blank" rel="noreferrer">
                        <img loading="lazy" src="https://d3esz4e2jyp077.cloudfront.net/landing/images/social/instagram.svg" alt="" />
                    </a>
                    <a className="cursor-pointer icon me-2 icon-xs rounded-sm shadow-l mr-1 bg-dark" href="https://x.com/influns_in" target="_blank" rel="noreferrer">
                        <img loading="lazy" src="https://d3esz4e2jyp077.cloudfront.net/landing/images/social/x.svg" alt="My Happy SVG" />
                    </a>
                    <a className="cursor-pointer icon me-2 icon-xs rounded-sm shadow-l mr-1 bg-linkedin" href="https://www.linkedin.com/company/influns-in/" target="_blank" rel="noreferrer">
                        <img loading="lazy" src="https://d3esz4e2jyp077.cloudfront.net/landing/images/social/linkedin.svg" alt="" />
                    </a>
                </div>
                <div className="divider mb-3"></div>
                <div className="row text-center mb-3 pl-3 pr-3">
                    <a className="font-11 col-4" target="_blank" rel="noreferrer" href={LANDING_PAGE_URL+'/legal/privacy.html'}>Privacy Policy</a>
                    <a className="font-11 col-4" target="_blank" rel="noreferrer" href={LANDING_PAGE_URL+'/legal/terms.html'}>Terms of Service</a>
                    <a className="font-11 col-4" target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help.">Contact Support</a>
                </div>
            </div>

        </div>
    )
}

export default AppInfo